export var APP_ROUTES = {
    landing: {
        id: 'langind-page-id',
        route: '/landing',
    },
    auth: {
        id: 'auth-layout-id',
        route: '/auth',
    },
    designing: {
        id: 'home-layout-id',
        route: '/designing',
    },
};
